"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.magFromTo = exports.pairId = exports.formatPerGranularity = exports.parseFormattedDate = exports.formatCounterValueHashes = exports.formatCounterValueHour = exports.formatCounterValueDay = exports.datapointLimits = exports.incrementPerGranularity = exports.encodePairAsLedgerIdPair = exports.encodeCurrencyAsLedgerId = void 0;
const encodeCurrencyAsLedgerId = (currency) => {
    switch (currency.type) {
        case "FiatCurrency": {
            return currency.ticker;
        }
        case "CryptoCurrency":
        case "TokenCurrency": {
            return encodeURIComponent(currency.id);
        }
    }
};
exports.encodeCurrencyAsLedgerId = encodeCurrencyAsLedgerId;
const encodePairAsLedgerIdPair = (from, to) => {
    // at the moment, the "to" uses the .ticker in the countervalues API
    return `${(0, exports.encodeCurrencyAsLedgerId)(from)}:${to.ticker}`;
};
exports.encodePairAsLedgerIdPair = encodePairAsLedgerIdPair;
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;
exports.incrementPerGranularity = {
    daily: DAY,
    hourly: HOUR,
};
exports.datapointLimits = {
    daily: 9999 * DAY,
    hourly: 7 * DAY, // we fetch at MOST a week of hourly. after that there are too much data...
};
/**
 * efficient implementation of YYYY-MM-DD formatter
 * @memberof countervalue
 */
const formatCounterValueDay = (d) => d.toISOString().slice(0, 10);
exports.formatCounterValueDay = formatCounterValueDay;
/**
 * efficient implementation of YYYY-MM-DDTHH formatter
 * @memberof countervalue
 */
const formatCounterValueHour = (d) => d.toISOString().slice(0, 13);
exports.formatCounterValueHour = formatCounterValueHour;
/**
 * full version of formatCounterValue*
 */
const formatCounterValueHashes = (d) => {
    const iso = d.toISOString();
    return {
        iso,
        day: iso.slice(0, 10),
        hour: iso.slice(0, 13),
    };
};
exports.formatCounterValueHashes = formatCounterValueHashes;
const parseFormattedDate = (str) => {
    let full = str;
    switch (str.length) {
        case 10:
            full += "T00:00";
            break;
        case 13:
            full += ":00";
            break;
    }
    full += ":00.000Z";
    return new Date(full);
};
exports.parseFormattedDate = parseFormattedDate;
exports.formatPerGranularity = {
    daily: exports.formatCounterValueDay,
    hourly: exports.formatCounterValueHour,
};
function pairId({ from, to }) {
    return (0, exports.encodePairAsLedgerIdPair)(from, to);
}
exports.pairId = pairId;
function magFromTo(from, to) {
    return Math.pow(10, (to.units[0].magnitude - from.units[0].magnitude));
}
exports.magFromTo = magFromTo;
//# sourceMappingURL=helpers.js.map